// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__djsKx","productName":"Table_productName__3XwH9"};